export default function AttributeValueDisplay({
  value,
}: {
  value: string | null
}) {
  const isColorCode = (val: string | null): val is string => {
    if (!val) return false
    return val.startsWith("#") && (val.length === 4 || val.length === 7)
  }

  if (value === null) {
    return <span className="text-gray-400 italic text-sm">N/A</span>
  }

  return (
    <>
      {isColorCode(value) ? (
        <div className="flex items-center gap-2">
          <div
            className="h-4 w-4 rounded-sm border border-gray-200"
            style={{ backgroundColor: value }}
          />
          <span className="text-sm font-mono">{value}</span>
        </div>
      ) : (
        <>{value}</>
      )}
    </>
  )
}
